import { render, staticRenderFns } from "./RegistrationRoute.vue?vue&type=template&id=73f7a933&"
import script from "./RegistrationRoute.vue?vue&type=script&lang=ts&"
export * from "./RegistrationRoute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports